// extracted by mini-css-extract-plugin
module.exports = {"center":"select-role_center__3tl-o","select-role":"select-role_select-role__2UkNx","lozenge":"select-role_lozenge__jYPom","input-button":"select-role_input-button__Z6te6"};